// filepath: /Users/omaric/Documents/GitHub/SEniors-Inshallah-/scad-system/src/utils/notificationUtils.js
import { useNotifications } from '../contexts/notification';

/**
 * Hook for sending application notifications to companies
 * @returns {Object} Functions for company notifications
 */
export const useCompanyNotifications = () => {
  const notificationContext = useNotifications();

  // Notify company when an application is accepted/rejected
  const notifyApplicationStatusChange = (application, status) => {
    notificationContext.notifyApplicationStatusChange(application, status);
  };

  // Notify company when a new application is received
  const notifyNewApplication = (application) => {
    notificationContext.notifyNewApplication(application);
  };

  return {
    notifyApplicationStatusChange,
    notifyNewApplication
  };
};

/**
 * Hook for sending SCAD Office notifications
 * @returns {Object} Functions for SCAD Office notifications
 */
export const useScadOfficeNotifications = () => {
  const notificationContext = useNotifications();

  // Notify SCAD Office when an appointment is accepted
  const notifyAppointmentAccepted = (appointment) => {
    notificationContext.notifyAppointmentAccepted(appointment);
  };

  return {
    notifyAppointmentAccepted
  };
};

/**
 * Hook for sending Pro Student notifications
 * @returns {Object} Functions for Pro Student notifications
 */
export const useProStudentNotifications = () => {
  const notificationContext = useNotifications();

  // Notify about internship cycle
  const notifyInternshipCycle = (cycle, isUpcoming = false) => {
    notificationContext.notifyInternshipCycle(cycle, isUpcoming);
  };

  // Notify about report status
  const notifyReportStatus = (report) => {
    if (!report.studentType) {
      report.studentType = 'proStudent';
    }
    notificationContext.notifyReportStatus(report);
  };

  // Notify about upcoming workshop
  const notifyUpcomingWorkshop = (workshop) => {
    notificationContext.notifyUpcomingWorkshop(workshop);
  };

  // Notify about workshop messages
  const notifyWorkshopMessage = (message, workshop) => {
    notificationContext.notifyWorkshopMessage(message, workshop);
  };

  // Notify about appointment acceptance
  const notifyAppointmentAccepted = (appointment) => {
    notificationContext.notifyStudentAppointmentAccepted(appointment);
  };

  return {
    notifyInternshipCycle,
    notifyReportStatus,
    notifyUpcomingWorkshop,
    notifyWorkshopMessage,
    notifyAppointmentAccepted
  };
};

/**
 * Hook for sending Student notifications
 * @returns {Object} Functions for Student notifications
 */
export const useStudentNotifications = () => {
  const notificationContext = useNotifications();

  // Notify about internship cycle
  const notifyInternshipCycle = (cycle, isUpcoming = false) => {
    notificationContext.notifyInternshipCycle(cycle, isUpcoming);
  };

  // Notify about report status
  const notifyReportStatus = (report) => {
    if (!report.studentType) {
      report.studentType = 'student';
    }
    notificationContext.notifyReportStatus(report);
  };

  return {
    notifyInternshipCycle,
    notifyReportStatus
  };
};